module.exports = __webpack_public_path__ + "static/media/bradcam.a12e0353.png";